import { connect } from 'react-redux';
import { ApplicationState } from '../../../redux/reducers';
import Payments from './Payments';

interface StateProps {
}

interface DispatchProps {
}

interface OwnProps {}

export type AllProps = StateProps & DispatchProps & OwnProps;

const mapStateToProps = (state: ApplicationState) => {
  return {
    
  }
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Payments);